
import Product from "@/types/Product";
import { defineComponent, PropType, ref } from "vue";
import Modal from "../General/Modal.vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiClose, mdiLoading } from "@mdi/js";
import { Inertia } from "@inertiajs/inertia";
import Messages from "../General/Messages.vue";
import TextButton from "../Buttons/TextButton.vue";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: () => false,
    },
    url: {
      type: String,
      required: true,
    },
    header:{
    type: String,
    required: true
    },
    action:{
      type: String,
      required: true
    },
    messages:{
      type: Array<string>,
      required: true
    }
  },
  emits: ["dismiss"],
  setup(props, context) {
    const doingAction = ref(false);

    const doAction = () => {
      doingAction.value = true;

      Inertia.post(props.url, {},{
        onFinish: () => {
          doingAction.value = false;
          context.emit("dismiss");
        },
      });
    };

    return {
      doAction,
      doingAction,
      closeIcon: mdiClose,
      loadingIcon: mdiLoading,
    };
  },
  components: { Modal, Button, SvgIcon, Messages, TextButton },
});
